import React from 'react';



type Props = {
  className?: string;
}
export const PlusVector: React.FC<Props> = ({ className }) => {
  return (
    <svg className = { className } width = '16' height = '16' viewBox = '0 0 16 16' fill = 'none' xmlns = 'http://www.w3.org/2000/svg'>
      <circle fill = 'currentColor' cx = '8' cy = '8' r = '8' />
      <path stroke = 'currentColor' strokeLinejoin = 'round' d = 'M8 4V12M12 8H4' />
    </svg>
  );
};
